/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ApolloError } from "@apollo/client";
import { KpiTimePeriod } from "~/generated/graphql";
import { BrickLoader, UniversalWrap, KpiWidgets } from "~/components";
import { KpiDetails } from "~/components/KPI/types";
import { KpiType } from "~/constants/kpi";
import { useQueryState } from "~/hooks";
import { Maybe } from "~/tools";

type KpiQueryState = {
  costTab?: number;
  kpiType?: KpiType;
  period?: KpiTimePeriod;
};

type Props = {
  overallWaste?: Maybe<KpiDetails>;
  nonProdHours?: Maybe<KpiDetails>;
  loading: boolean;
  error: ApolloError | undefined;
  selectedType: KpiType;
};

export function OrgUnitKpiWidget({
  overallWaste,
  nonProdHours,
  loading,
  error,
  selectedType,
}: Props) {
  const {
    state: { period = KpiTimePeriod.ThreeMonths, costTab },
    setQueryState,
  } = useQueryState<KpiQueryState>();

  const onClick = (type: KpiType) =>
    setQueryState({
      kpiType: type,
      period,
      costTab,
    });

  return (
    <UniversalWrap
      loaderProps={{
        loading,
        Component: BrickLoader,
        viewBox: "0 0 10 1",
      }}
      errorProps={{
        error,
      }}
    >
      <KpiWidgets
        overallWaste={overallWaste}
        nonProdHours={nonProdHours}
        selectedType={selectedType}
        allowedWidgets={[KpiType.OVERALL_WASTE, KpiType.NON_PROD_HOURS]}
        onClick={onClick}
      />
    </UniversalWrap>
  );
}
